import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecommendationsComponent } from './recommendations.component';
import { RecommendationcardComponent } from './recommendationcard/recommendationcard.component';
import { AngularMaterialModule } from '../../material.module';
import { KeywordsModule } from '../keywords/keywords.module';
import { ImagesliderComponent } from '../imageslider/imageslider.component';
import { ShareComponent } from '../share/share.component';
import { PipeModule } from '@app/pipe/pipe.module';

@NgModule({
    declarations: [RecommendationsComponent, RecommendationcardComponent],
    imports: [
        CommonModule,
        AngularMaterialModule,
        ShareComponent,
        ImagesliderComponent,
        KeywordsModule,
        PipeModule
    ],
    exports: [
        RecommendationsComponent
    ]
})
export class RecommendationsModule { }
